import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {GenerateStoriesAIPayload, ExternalGptConfig} from '../models/generate-stories-dialog';
import {BaseDaoService} from '@q9elements/ui-kit/common';
import {AIStoryGenerationStatus} from 'src/app/shared/models/generation-status.interface';

@Injectable()
export class GenerateStoriesAIService extends BaseDaoService {
  public generateStoriesAI(diagramId: string, payload: GenerateStoriesAIPayload) {
    const url = `${this.apiUrl}/elements-gpt/${diagramId}/diagram/state/draft`;

    return this.http.post<AIStoryGenerationStatus | null>(url, payload);
  }

  public getExternalGptConfig(): Observable<ExternalGptConfig> {
    const url = `${this.apiUrl}/enterprises/external-gpt-config`;

    return this.http.get<ExternalGptConfig>(url);
  }
}
